<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <div class="row-tb-head" style="margin-top: 10px">
      <span>加工后存货明细</span>
    </div>
    <div style="display: flex; font-size: 14px; line-height: 30px; color: #606266; margin-bottom: 10px">
      <div>多选操作：</div>
      <div style="display: flex">
        <div></div>
        <div style="margin: 0 10px">
          <el-date-picker :disabled="!selList.length" v-model="batchDocDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="批量修改选中单据日期" @change="onDocDate">
          </el-date-picker>
        </div>
      </div>
      <div style="display: flex">
        <div>预计完工日期</div>
        <div style="margin: 0 10px">
          <el-date-picker :disabled="!selList.length" v-model="batchEndTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" placeholder="批量修改选中预计完工日期" @change="onDocEndTime">
          </el-date-picker>
        </div>
      </div>
    </div>
    <el-table
      :data="Products"
      class="table_bottom table-line tb-c-head"
      max-height="353"
      @row-click="rowClick"
      :row-class-name="tableRowClassName"
      :highlight-current-row="true"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" fixed="left"></el-table-column>
      <el-table-column type="index" label="序号" fixed="left" />
      <el-table-column prop="OrderProductNo" label="布产单号" min-width="120"></el-table-column>
      <el-table-column prop="WorkDocNo" label="工单号" min-width="120"></el-table-column>
      <el-table-column prop="Pno" label="加工后存货编码" min-width="120"></el-table-column>
      <el-table-column prop="Pname" label="加工后存货名称" min-width="120" fixed="left"></el-table-column>
      <el-table-column prop="ProductSpec" label="规格" min-width="120"></el-table-column>
      <el-table-column prop="PropertyName" label="加工后属性" min-width="120"></el-table-column>
      <el-table-column prop="ColorName" label="加工后颜色" min-width="120"></el-table-column>
      <el-table-column prop="PdUnitName" label="单位" min-width="120"></el-table-column>
      <el-table-column prop="Quantity" label="需求数量" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-if="Status === 0" v-model="row.qua" @change="changePQuantity($event, row)" />
          <span v-else>{{ $commonJs.toThousands(row.qua) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ImgUrl" label="图片" min-width="120">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="Remarks"
        label="备注"
        min-width="120"
      ></el-table-column> -->

      <el-table-column prop="StockQuantity" label="库存数量" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.StockQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ExistQuantity" label="可用量" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.ExistQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="生产数量" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ row.qua - (row.StockQuantity ?? 0) < 0 ? 0 : row.qua - (row.StockQuantity ?? 0) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="InQuantity" label="累计入库数" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.InQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="未入库数" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ row.qua && row.InQuantity ? (row.qua - row.InQuantity > 0 ? row.qua - row.InQuantity : 0) : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="PickingWarehouseId" label="预入仓" min-width="120">
        <template slot-scope="{ row }">
          <el-select v-model="row.PickingWarehouseId">
            <el-option label="无" :value="0"></el-option>
            <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column key="column1" v-if="!QuickProcess" prop="SchedulingType" label="排产类型" min-width="120">
        <template slot-scope="{ row }">
          <el-select v-if="Status === 0" v-model="row.SchedulingType" @change="changeSchedulingType($event, row)" v-show="!QuickProcess">
            <el-option key="SchedulingType1" label="部门" :value="0"></el-option>
            <el-option key="SchedulingType2" label="设备" :value="1"></el-option>
          </el-select>
          <span v-else>{{ row.SchedulingType === 0 ? '部门' : '设备' }}</span>
        </template>
      </el-table-column>
      <el-table-column key="column2" v-if="!QuickProcess" label="生产部门/设备" min-width="120">
        <template slot-scope="{ row }">
          {{row.SchedulingType}}
          <dp-select v-if="row.showDp" style="width: 180px" :disabled="Status === 1" @input="editT(row)" v-model="row.DpId" v-show="row.showDp"/>
          <el-select v-else style="width: 180px" @input="editT(row)" :disabled="Status === 1" v-model="row.MaintenanceId" v-show="row.showMt" @change="changeEquipment(row, $event)">
            <el-option v-for="item in equipmentList" :key="item.EquipmentId" :label="item.EquipmentName" :value="item.EquipmentId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="生产部门" min-width="120" key="column2" v-else>
        <template slot-scope="{ row }">
          <dp-select v-show="row.ProductionType == 0" style="width: 180px" @input="editT(row)" :disabled="Status === 1" v-model="row.DpId" />
        </template>
      </el-table-column>
      <el-table-column prop="ProductionType" label="生产类型" min-width="120">
        <template slot-scope="{ row }">
          <el-select v-model="row.ProductionType" @change="editT(row)" v-if="Status === 0">
            <el-option v-if="row.currentProductNature === 2 || row.currentProductNature === 0" key="ProductionType1" label="自产" :value="0"></el-option>
            <el-option v-if="row.currentProductNature === 2 || row.currentProductNature === 1" key="ProductionType2" label="委外" :value="1"></el-option>
          </el-select>
          <span v-else>{{ row.ProductionType === 0 ? '自产' : '委外' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="ProductionDpId" label="加工商" min-width="120">
        <template slot-scope="{ row }">
          <!-- <dp-select
            v-if="row.ProductionType !== 1"
            style="width: 180px"
            @input="editT(row)"
            :disabled="Status === 1"
            v-model="row.ProductionDpId"
          /> -->
          <el-select v-model="row.ProductionDpId" @change="editT(row)" v-if="row.ProductionType === 1" :disabled="row.ProductionType === 1 && Status !== 0" filterable>
            <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :label="item.FullName" :value="item.TradeUnitId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="DocDate" label="单据日期" min-width="120">
        <template slot-scope="{ row }">
          <el-date-picker v-if="Status === 0" v-model="row.DocDate" @change="editT(row)" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" placeholder="选择日期"> </el-date-picker>
          <span v-else>{{ row.DocDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="EndTime" label="预计完工日期" min-width="160">
        <template slot-scope="{ row }">
          <el-date-picker v-if="Status === 0" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="row.EndTime" @change="editT(row)" type="date" placeholder="选择日期"> </el-date-picker>
          <span v-else>{{ row.EndTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="工单备注" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.Remark" type="text" @change="editT(row)" v-if="Status === 0"></el-input>
          <span v-else>{{ row.Remark }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="80">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="delPro(row, $index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="row-tb-head" style="margin-top: 10px">
      <span v-show="isShowTabs">加工前存货明细</span>
    </div>
    <div class="flex1" v-if="Status === 0" v-show="isShowTabs">
      <div>{{ isShowTabs ? itemDetailModels[0].Pname : '' }}</div>
    </div>
    <div v-for="(item, index) in itemDetailModels" :key="index" v-show="isShowTabs">
      <el-table :data="item.DetailModels" class="table_bottom table-line tb-c-head" border>
        <el-table-column prop="Pno" label="加工前存货编码" min-width="120"></el-table-column>
        <el-table-column prop="Pname" label="加工前存货名称" min-width="120"></el-table-column>
        <el-table-column prop="ProductSpec" label="规格" min-width="120"></el-table-column>
        <el-table-column prop="PropertyName" label="加工前属性" min-width="120">
          <template slot-scope="{ row }">
            <el-select v-model="row.PropertyId" v-show="row.UseProcess" @change="changeProperty($event, row)">
              <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ColorName" label="加工前颜色" min-width="120">
          <template slot-scope="{ row }">
            <el-select v-if="Status === 0" v-model="row.ColorId" v-show="row.UseColor" @change="changeColor($event, row)">
              <el-option v-for="item in row.Colors" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName"></el-option>
            </el-select>
            <span v-else>{{ row.ColorName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="PdUnitName" label="单位" min-width="120"></el-table-column>
        <el-table-column prop="Quantity" label="需求数量" min-width="120">
          <template slot-scope="{ row }">
            <el-input clearable v-if="Status === 0" @change="changeQua($event, row)" v-model="row.qua" placeholder="请输入数量" type="number" />
            <span v-else>{{ $commonJs.toThousands(row.qua) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ImgUrl" label="图片" min-width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="Remarks" label="备注" min-width="120">
          <template slot-scope="{ row }">
            <el-input v-if="Status === 0" clearable v-model="row.Remarks" @change="changeRemarks($event, row)" placeholder="请输入备注" type="text" />
            <span v-else>{{ row.Remarks }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="StockQuantity" label="库存数量" min-width="120">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.StockQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ExistQuantity" label="可用量" min-width="120">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.ExistQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="linyongQua" label="领用数量" min-width="120">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.linyongQua) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <come-list-dialog @select="comeSelect" ref="comeListDialog" in-dialog />
    <img-dialog ref="imgDialog" :imgs="imgs" />
  </div>
</template>
<script>
import comeListDialog from '@/components/basedata/business/come/listDialog'
import { urlHttp } from './bomConfig'
import imgDialog from './imgDialog'
import dpSelect from './dpSelect'
import vSelect from './vSelect'

export default {
  components: {
    comeListDialog,
    imgDialog,
    dpSelect,
    vSelect
  },
  data() {
    return {
      tableData: [],
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      pdApi: require('@/api/ba/product').default,
      tradeUnitList: [],
      propertyApi: require('@/api/ba/property').default,
      propertyList: [],
      currentRow: null,
      DetailModels: [],
      Products: [],
      imgs: [],
      deleteProducts: [],
      deleteProcessModels: [],
      deleteDetailModels: [],
      equipmentList: [],
      itemProcessModels: [],
      itemDetailModels: [],
      isShowTabs: false,
      warehouseList: [],
      selList: '', //选中行的列表
      batchDocDate: null, //批量单据日期
      batchEndTime: null //预计完工日期
    }
  },
  props: {
    Status: {
      type: Number,
      default: 0
    },
    QuickProcess: {
      type: Boolean,
      default: false
    },
    scQuantity: {
      type: Number,
      default: 1
    },
    SpecialBoms: {
      type: Object,
      default: () => {}
    },
    editSpecial: {
      type: Array,
      default: () => []
    },
    OrderProductNo: {
      type: String,
      default: ''
    },
    productLists: {
      type: Array,
      default: () => []
    },
    editType: {
      type: Number,
      default: 0
    },
    tradeUnitListProp: {
      type: Array,
      default: () => []
    },
    propertyListProp: {
      type: Array,
      default: () => []
    },
    equipmentListProp: {
      type: Array,
      default: () => []
    },
    warehouseProp: {
      type: Array,
      default: () => []
    },
    isCheckCapacity: {
      type: Boolean,
      default: () => false
    }
  },
  created() {
    // this.tradeUnitApi.list({ TradeUnitTypes: [1, 3], Status: 1 }).then((res) => {
    //   if (res.Code === 0) {
    //     this.tradeUnitList = res.Data;
    //   }
    // });
    // this.propertyApi.list({Status: 1}).then(res => {
    //   if(res.Code === 0){
    //     this.propertyList = res.Data;
    //   }
    // })
    this.getequipmentList();
  },
  watch: {
    propertyListProp(val) {
      this.propertyList = val
    },
    tradeUnitListProp(val) {
      this.tradeUnitList = val
    },
    equipmentListProp(val) {
      this.equipmentList = val
    },
    scQuantity(val) {
      this.DetailModels.forEach(item => {
        item.DetailModels.forEach(v => {
          if (v.qua) {
            if (this.editType === 1 && v.T !== 0) {
              v.T = 1
            }
            v.qua = Math.ceil(v.Quantity * val)
          }
        })
      })

      this.Products.forEach(item => {
        if (item.qua) {
          if (this.editType === 1 && item.T !== 0) {
            item.T = 1
          }
          item.qua = Math.ceil(item.Quantity * val)
        }
      })
    },
    SpecialBoms(val) {
      console.log('SpecialBoms ==== val', val)

      let { Bom, DetailModels, ProcessModels } = val

      Bom.forEach(item => {
        item.currentProductNature = item.ProductNature
        if (item.ProductNature === 2) {
          item.ProductNature = 0
        }
        this.$set(item, 'T', 0)
        this.$set(item, 'WorkDocId', 0)
        this.$set(item, 'WorkDocProductId', 0)
        this.$set(item, 'WorkDocNo', '')
        this.$set(item, 'StockQuantity', item.StockQuantity)
        this.$set(item, 'ExistQuantity', item.ExistQuantity)
        this.$set(item, 'SchedulingType', null)
        this.$set(item, 'DpId', null)
        this.$set(item, 'MaintenanceId', null)
        this.$set(item, 'ProductionType', item.ProductNature)
        this.$set(item, 'ProductionDpId', item.DefaultSupplier)
        this.$set(item, 'DocDate', this.$commonJs.getToday())
        this.$set(item, 'EndTime', this.$commonJs.getToday())
        this.$set(item, 'Remark', '')
        this.$set(item, 'Pno', item.ProductNo)
        this.$set(item, 'Pname', item.ProductName)
        this.$set(item, 'PickingWarehouseId', null)
      })

      Bom.forEach(item => {
        this.$set(item, 'qua', item.Quantity * this.scQuantity)
      })

      this.Products = Bom
      // let _DetailModels = [];
      // let arr = [];
      // val.forEach(item => {
      //   let {DetailModels, ...rest} = item;
      //   // let MouldName = rest.MouldName;
      //   // let MouldNo = rest.MouldNo;

      //   let {Pname, Pno, ProductSpec} = DetailModels[0]

      //   rest.Pname = Pname;
      //   rest.Pno = Pno;
      //   rest.ProductSpec = ProductSpec;

      DetailModels.forEach(item => {
        item.DetailModels.forEach(v => {
          v.T = 0
          v.WorkDocMaterialId = 0
          v.WorkDocId = 0
          v.Ration = 0
          v.RationUnit = 0
          v.Rate = 0
          v.Loss = 0
          v.Remarks = ''
          v.rateQua = item.fqua / v.Quantity
          this.$set(v, 'qua', v.Quantity * this.scQuantity)
          v.Pno = v.ProductNo
          v.Pname = v.ProductName
        })
      })

      this.DetailModels = DetailModels

      //   _DetailModels.push(...DetailModels)

      //   arr.push(rest)

      // })

      // this.DetailModels = _DetailModels;

      // arr.forEach(item => {
      //   this.$set(item, 'T', 0);
      //   this.$set(item, 'WorkDocId', 0);
      //   this.$set(item, 'WorkDocProductId', 0);
      //   this.$set(item, 'WorkDocNo', "");
      //   this.$set(item, 'StockQuantity', 0);
      //   this.$set(item, 'SchedulingType', null);
      //   this.$set(item, 'DpId', null);
      //   this.$set(item, 'MaintenanceId', null);
      //   this.$set(item, 'ProductionType', item.ProductNature);
      //   this.$set(item, 'ProductionDpId', item.DefaultSupplier);
      //   this.$set(item, 'DocDate', this.$commonJs.getToday());
      //   this.$set(item, 'EndTime', this.$commonJs.getToday());
      //   this.$set(item, 'Remark', "");
      // })

      // arr.forEach(item => {
      //     this.$set(item, 'qua', item.Quantity * this.scQuantity);
      //   })

      // this.Products = arr
    },
    editSpecial(val) {
      let _ProductModels = []
      let _ProcessModels = []
      let _MaterialModels = []

      console.log('特殊工单触发更新', val)

      val.forEach(item => {
        let { MaterialModels, ProcessModels, ProductModels, ...rest } = item

        MaterialModels.forEach(item => {
          item.PdUnitName = item.UnitName
          item.PdUnitId = item.QuantityUnit
          item.Pname = item.ProductName
          item.Pno = item.ProductNo

          this.$set(item, 'qua', item.Quantity * this.scQuantity)
        })

        ProductModels.forEach(item => {
          item.OrderProductNo = this.OrderProductNo
          item.Pname = item.ProductName
          item.Pno = item.ProductNo
          item.Bomno = item.ChildGroupNo !== '' && item.ChildGroupNo != null ? item.ChildGroupNo : item.Bomno

          item.currentProductNature = item.ProductNature

          for (let i in rest) {
            if (!item.hasOwnProperty(i)) {
              this.$set(item, i, rest[i])
            }
          }

          let o1 = {
            pid: item.ProductId,
            Pname: item.ProductName,
            fqua: item.Quantity,
            DetailModels: MaterialModels
          }

          _MaterialModels.push(o1)

          // let o = {
          //   Pname: item.ProductName,
          //   Pno: item.ProductNo,
          //   pid: item.ProductId,
          //   Processes: ProcessModels
          // }

          // _ProcessModels.push(o)
        })

        _ProductModels.push(...ProductModels)
      })

      _ProductModels.forEach(item => {
        this.$set(item, 'qua', item.Quantity * this.scQuantity)
      })

      _MaterialModels.forEach(item => {
        item.DetailModels.forEach(v => {
          v.rateQua = item.fqua / v.Quantity
        })
      })

      this.changeT(_ProductModels)
      // this.changeT(_ProcessModels, 2)
      this.changeT(_MaterialModels, 1)

      this.Products = _ProductModels
      this.ProcessModels = _ProcessModels
      this.DetailModels = _MaterialModels
    },
    productLists(val) {},
    warehouseProp(val) {
      this.warehouseList = val
    }
  },
  methods: {
    getequipmentList() {
      this.equipmentApi.list({ Statuses: [1, 2] }).then(res => {
        if (res.Code === 0) {
          this.equipmentList = res.Data
          console.log(this.equipmentList, 'eq')
        }
      })
    },
    
     changeEquipment(row, val) {
      console.log(val, row, 'changeEquipment')
      this.getCapacity(val, row)
    },
    getCapacity(val, row) {
      this.equipmentApi.checkCapacity({ EquipmentId: val }).then(res => {
        if (res.Code === 0) {
          var obj = res.Data
          console.log(obj, row, 'obj')
          var hours = 0
          if (row.qua) {
            hours = Math.ceil(row.qua / obj.info.Workload)
            console.log(hours, obj.info.Workload, 'hours3')
          }
          console.log(hours, 'hours')
          if (obj.workdoc) {
            if (obj.workdoc.EndTime) {
              var endtime = new Date(obj.workdoc.EndTime)
              var newEndTime = new Date(endtime.getTime() + hours * 60 * 60 * 1000)
              var et = new Date(row.EndTime)
              if (newEndTime.getTime() > et.getTime()) {
                this.$confirm('完工时间比预设完工时间久, 是否替换预设完工时间?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                  .then(() => {
                    row.EndTime = this.$commonJs.toDatetimeString(newEndTime)
                  })
                  .catch(() => {})
              }
            }
          } else {
            var endtime = new Date()
            var newEndTime = new Date(endtime.getTime() + hours * 60 * 60 * 1000)
            var et = new Date(row.EndTime)
            if (newEndTime.getTime() > et.getTime()) {
              this.$confirm('完工时间比预设完工时间久, 是否替换预设完工时间?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  row.EndTime = this.$commonJs.toDatetimeString(newEndTime)
                })
                .catch(() => {})
            }
          }
        }
      })
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    jsonCopy(data) {
      return JSON.parse(JSON.stringify(data))
    },
    changePQuantity(val, row) {
      let { index } = row
      let detailModels = this.DetailModels[index].DetailModels
      console.log('detailModels', detailModels)

      if (row.T !== 0) {
        row.T = 1
      }
      if (detailModels.length !== 0) {
        detailModels.forEach(item => {
          if (item.T !== 0) {
            item.T = 1
          }
          item.qua = val / item.rateQua
        })
      }
    },

    // 表格行点击，根据存货，显示对应的数据到工艺和产品子件
    rowClick(row) {
      let { index } = row
      console.log('index', index)

      this.itemProcessModels = []
      this.itemDetailModels = []
      let _itemProcessModels = []
      let _itemDetailModels = []

      // _itemProcessModels.push(this.jsonCopy(this.ProcessModels[index]) )
      _itemDetailModels.push(this.jsonCopy(this.DetailModels[index]))

      // this.itemProcessModels = _itemProcessModels;
      this.itemDetailModels = _itemDetailModels

      // console.log('this.itemProcessModels', this.itemProcessModels)
      console.log('this.itemDetailModels', this.itemDetailModels)

      this.isShowTabs = true
    },
    delPro(row, i) {
      this.$confirm('确定删除这条记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        let { index } = row

        if (row.T !== 0) {
          let delProduct = this.Products[index]
          delProduct.T = 2
          this.deleteProducts.push(delProduct)
        }

        console.log('this.DetailModels', this.DetailModels)

        let detailBom = this.DetailModels.filter(item => {
          return item.pid === row.ProductId
        })[0]

        detailBom.DetailModels.forEach(item => {
          item.delete = true
          if (item.T !== 0) {
            item.T = 2
            this.deleteDetailModels.push(detailBom)
          }
        })
        console.log('this.deleteDetailModels', this.deleteDetailModels)

        let dindex = this.DetailModels.findIndex(item => {
          return item.pid === detailBom.pid
        })

        // let dindex1 = this.ProcessModels.findIndex((item) => {
        //   return item.pid === row.ProductId;
        // });
        // let ProcessModelsObj = this.ProcessModels[dindex1];
        // if (ProcessModelsObj.T !== 0) {
        //   ProcessModelsObj.T = 2;
        //   this.deleteProcessModels.push(ProcessModelsObj);
        // }

        this.Products.splice(index, 1)
        this.DetailModels.splice(dindex, 1)

        this.isShowTabs = false
        // this.ProcessModels.splice(dindex1, 1);
      })
    },
    setList(data, dataProductId = 0) {
      console.log('特殊', data)
      if (this.Products.length !== 0) {
        if (data.delete) {
          // 查找对应父件的index，进行删除
          let index = this.Products.findIndex(item => {
            return data.ChildBomNo === item.Bomno
          })
          if (index === -1) {
            return
          }
          let id = this.Products[index].ProductId

          if (dataProductId !== 0) {
            id = dataProductId
          }

          if (this.Products[index].T !== 0) {
            let delProduct = this.Products[index]
            delProduct.T = 2
            this.deleteProducts.push(delProduct)
          }

          this.Products.splice(index, 1)
          console.log('this.DetailModels', this.DetailModels)

          let detailBom = this.DetailModels.filter(item => {
            return item.pid === id
          })[0]

          detailBom.DetailModels.forEach(item => {
            item.delete = true
            if (item.T !== 0) {
              item.T = 2
              this.deleteDetailModels.push(detailBom)
            }
          })

          let dindex = this.DetailModels.findIndex(item => {
            return item.pid === detailBom.pid
          })

          // let dindex1 = this.ProcessModels.findIndex(item => {
          //   return item.pid === id
          // })
          // let ProcessModelsObj = this.ProcessModels[dindex1]
          // if(ProcessModelsObj.T !== 0){
          //   ProcessModelsObj.T = 2;
          //   this.deleteProcessModels.push(ProcessModelsObj)
          // }

          this.DetailModels.splice(dindex, 1)
          // this.ProcessModels.splice(dindex1, 1)
        } else if (data.add) {
          if (!data.isAddList) {
            data.Bomno = data.ChildBomNo
            this.$set(data, 'T', 0)
            this.$set(data, 'WorkDocId', 0)
            this.$set(data, 'WorkDocProductId', 0)
            this.$set(data, 'WorkDocNo', '')
            this.$set(data, 'StockQuantity', 0)
            this.$set(data, 'ExistQuantity', 0)
            this.$set(data, 'SchedulingType', null)
            this.$set(data, 'DpId', null)
            this.$set(data, 'MaintenanceId', null)
            this.$set(data, 'ProductionType', data.ProductNature)
            this.$set(data, 'ProductionDpId', data.DefaultSupplier)
            this.$set(data, 'DocDate', this.$commonJs.getToday())
            this.$set(data, 'EndTime', this.$commonJs.getToday())
            this.$set(data, 'Remark', '')
            this.$set(data, 'Pno', data.ProductNo)
            this.$set(data, 'Pname', data.ProductName)
            this.$set(data, 'PickingWarehouseId', null)
            this.$set(data, 'OrderProductNo', data.OrderProductNo)

            this.Products.push(data)

            let _DetailModels = {
              ProductId: data.ProductId,
              Pno: data.ProductNo,
              Pname: data.ProductName,
              ProductSpec: data.ProductSpec,
              PropertyName: data.PropertyName,
              PropertyId: data.PropertyId,
              ColorName: data.ColorName,
              ColorId: data.ColorId,
              PdUnitName: data.PdUnitName,
              PdUnitId: data.PdUnitId,
              qua: data.qua,
              Quantity: data.Quantity,
              Remarks: data.Remarks,
              StockQuantity: data.StockQuantity,
              ExistQuantity: data.ExistQuantity,
              linyongQua: data.linyongQua,
              UseColor: data.UseColor,
              UseProcess: data.UseProcess,
              Colors: data.Colors,
              T: 0,
              WorkDocId: 0,
              WorkDocNo: '',
              WorkDocMaterialId: 0
            }

            let o = {
              Pname: data.ProductName,
              pid: data.ProductId,
              fqua: data.Quantity,
              DetailModels: [
                {
                  ..._DetailModels
                }
              ]
            }
            this.DetailModels.push(o)
          } else {
            let { ChildBomNo } = data
            let bom1 = this.Products.filter(item => {
              return item.Bomno === ChildBomNo
            })
            if (bom1.length === 0) {
              return
            }
            let bom = bom1[0]

            bom.Pname = data.ProductName
            bom.Pno = data.ProductNo
            bom.ProductSpec = data.ProductSpec
            bom.ProcessStage = data.ProcessStage
            bom.ProduceTypeName = data.ProduceTypeName
            bom.ProductId = data.ProductId
            bom.Colors = data.Colors
            bom.PdUnitName = data.PdUnitName
            bom.PdUnitId = data.PdUnitId
            bom.UseProcess = data.UseProcess
            bom.UseColor = data.UseColor

            bom.Mould = data.Mould
            bom.MouldId = data.MouldId
            bom.MouldName = data.MouldName

            bom.DefaultSupplier = data.DefaultSupplier
            bom.ProductNature = data.ProductNature
            bom.ColorId = data.ColorId
            bom.ColorName = data.ColorName
            bom.qua = data.qua
            bom.StockQuantity = data.StockQuantity
            bom.ExistQuantity = data.ExistQuantity

            // 找出父件对应的子件
            let childBom = this.DetailModels.filter(item => {
              return item.pid === bom.ProductId
            })

            if (childBom.length !== 0) {
              childBom[0].DetailModels.forEach(item => {
                item.qua = bom.qua / item.rateQua
              })
            }
          }
        } else {
          let { ChildBomNo } = data
          let bom1 = this.Products.filter(item => {
            return item.Bomno === ChildBomNo
          })[0]
          if (bom1.length === 0) {
            return
          }
          let bom = bom1[0]

          bom.Quantity = data.Quantity
          bom.T = data.T
          bom.Pname = data.ProductName
          bom.Pno = data.ProductNo
          bom.ProductSpec = data.ProductSpec
          bom.ProcessStage = data.ProcessStage
          bom.ProduceTypeName = data.ProduceTypeName
          bom.ProductId = data.ProductId
          bom.Colors = data.Colors
          bom.PdUnitName = data.PdUnitName
          bom.PdUnitId = data.PdUnitId
          bom.UseProcess = data.UseProcess
          bom.UseColor = data.UseColor

          bom.Mould = data.Mould
          bom.MouldId = data.MouldId
          bom.MouldName = data.MouldName

          bom.DefaultSupplier = data.DefaultSupplier
          bom.ProductNature = data.ProductNature

          bom.ColorId = data.ColorId
          bom.ColorName = data.ColorName
          bom.qua = data.qua
          bom.StockQuantity = data.StockQuantity
          bom.ExistQuantity = data.ExistQuantity

          // 找出父件对应的子件
          let childBom = this.DetailModels.filter(item => {
            return item.pid === bom.ProductId
          })[0]

          childBom.DetailModels.forEach(item => {
            item.qua = bom.qua / item.rateQua
            item.T = data.T
          })
        }
      }

      this.isShowTabs = false
    },
    changeT(data, type = 0) {
      if (type === 0) {
        data.forEach(item => {
          item.T = null
        })
      } else if (type === 1) {
        data.forEach(item => {
          item.DetailModels.forEach(v => {
            v.T = null
          })
        })
      } else if (type === 2) {
        data.forEach(item => {
          item.T = null
          item.Processes.forEach(v => {
            v.T = null
          })
        })
      }
    },
    editT(row) {
      // if(this.editType === 1 && row.T !== 0){
      //   row.T = 1;
      // }
    },
    changeProperty(val, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1
      }
      let item = this.propertyList.filter(item => {
        return item.PropertyId === val
      })[0]

      row.PropertyName = item.PropertyName
    },
    changeColor(val, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1
      }
      let item = row.Colors.filter(item => {
        return item.ColorId === val
      })[0]

      this.$message.info('颜色更改, bom版本可能不一致, 如有需要请手动更改')

      row.ColorName = item.ColorName
    },
    changeRemarks(val, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1
      }
    },
    changeQua(val, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1
      }
      val = parseFloat(val)
      if (!row.Quantity) {
        row.Quantity = val / this.scQuantity
      }
      if (!row.rateQua) {
        let pid = row.ProductId
        let obj = this.Products.filter(v => {
          return v.ProductId === pid
        })[0]
        row.rateQua = obj.Quantity / row.Quantity
      }
      row.qua = val
    },
    _getData(params) {
      this.getData(params)
    },
    selectCome(row) {
      this.currentRow = row
      this.$refs.comeListDialog.open()
    },
    comeSelect() {},
    changeSchedulingType(val, row) {
      console.log(val,'changeSchedulingType');
      this.editT(row)
      if (val === 0) {
        row.DpId = 0
        row.showDp = true
        row.showMt = false
      } else if (val === 1) {
        row.MaintenanceId = null
        row.showDp = false
        row.showMt = row.ProductionType == 0
      }
      console.log(row,'changeSchedulingType2');
    },
    base64ToFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg)
      const ImgUrl = res.Data
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！')
      let imgs = []
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl))
        // imgs.push(imgBlob)
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs
      this.$refs.imgDialog.open()
    },
    // viewImg(Imgs) {
    //   let imgUrls = Imgs.map((item) => item.ImgUrl);

    //   this.imgs = imgUrls;
    //   this.$refs.imgDialog.open();
    // },
    cycleChange(t) {
      var today = this.$commonJs.getToday()
      var start = ''
      var end = ''
      switch (t) {
        case '今天':
          start = today
          end = today
          break
        case '昨天':
          start = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
          end = start
          break
        case '近3天':
          start = this.$dayjs().subtract(2, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近7天':
          start = this.$dayjs().subtract(6, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近14天':
          start = this.$dayjs().subtract(13, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '本周':
          start = this.$dayjs().startOf('week').format('YYYY-MM-DD')
          end = today
          break
        case '上周':
          var week = this.$dayjs().subtract(1, 'week')
          start = week.startOf('week').format('YYYY-MM-DD')
          end = week.endOf('week').format('YYYY-MM-DD')
          break
        case '本月':
          start = this.$dayjs().startOf('month').format('YYYY-MM-DD')
          end = today
          break
        case '上月':
          var month = this.$dayjs().subtract(1, 'month')
          start = month.startOf('month').format('YYYY-MM-DD')
          end = month.endOf('month').format('YYYY-MM-DD')
          break
        case '本季':
          start = this.$dayjs().startOf('quarter').format('YYYY-MM-DD')
          end = today
          break
        case '上季':
          var quarter = this.$dayjs().subtract(1, 'quarter')
          start = quarter.startOf('quarter').format('YYYY-MM-DD')
          end = quarter.endOf('quarter').format('YYYY-MM-DD')
          break
        case '本年':
          start = this.$dayjs().startOf('year').format('YYYY-MM-DD')
          end = today
          break
        case '上年':
          var year = this.$dayjs().subtract(1, 'year')
          start = year.startOf('year').format('YYYY-MM-DD')
          end = year.endOf('year').format('YYYY-MM-DD')
          break
      }

      return {
        start,
        end
      }
    },
    filterData(data) {
      return data.filter(item => {
        return item.T != null
      })
    },
    sendData() {
      // 检查必填项目
      let keys = [] // 必填的字段
      // SchedulingType DpId MaintenanceId ProductionType  ProductionDpId
      this.Products.forEach(item => {
        if (!this.QuickProcess && item.SchedulingType == null) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: '排产类型'
          })
        } else if (item.SchedulingType === 0 && (item.DpId == null || item.DpId == 0) && !this.QuickProcess) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: '部门'
          })
        } else if (item.SchedulingType === 1 && (item.MaintenanceId == null || item.MaintenanceId == 0) && !this.QuickProcess) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: '设备'
          })
        }

        if (item.ProductionType !== 0 && item.ProductionDpId == null) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: '供应商'
          })
        }

        // if(item.PickingWarehouseId == null){
        //   keys.push({
        //     name: item.ProductName,
        //     id: item.ProductId,
        //     key: "领料仓库",
        //   });
        // }
      })

      if (keys.length !== 0) {
        // 构造提示信息
        let arr = Array.from(
          new Set(
            keys.map(item => {
              return item.id
            })
          )
        )

        let msgArr2d = []
        arr.forEach(item => {
          msgArr2d.push(
            keys.filter(v => {
              return v.id === item
            })
          )
        })

        let msgArr = []
        msgArr2d.forEach(item => {
          let name = item[0].name
          let keyStr = item
            .map(v => {
              return v.key
            })
            .join(',')
          msgArr.push(`请填写特殊工艺工单存货${name}一列中的${keyStr}`)
        })

        let msg = msgArr.join('<br/>')
        this.$message({
          type: 'warning',
          message: msg,
          dangerouslyUseHTMLString: true
        })

        return false
      }

      let length = this.Products.length
      let arr = []

      for (let i = 0; i < length; ++i) {
        let ProductModels = []
        let ProcessModels = []
        let MaterialModels = []

        // 对默认值进行设置
        let o = {
          T: this.Products[i].T,
          WorkDocProductId: this.Products[i].WorkDocProductId,
          WorkDocId: this.Products[i].WorkDocId,
          ProductId: this.Products[i].ProductId,
          PdUnitId: this.Products[i].PdUnitId,
          ProgrammeId: this.Products[i].ProgrammeId ?? 0,
          ColorId: this.Products[i].ColorId,
          PropertyId: this.Products[i].PropertyId,
          Quantity: this.Products[i].qua,
          TeProductId: this.Products[i].TeProductId ?? 0,
          StockQuantity: this.Products[i].StockQuantity,
          ExistQuantity: this.Products[i].ExistQuantity,
          SourceDtsId: 0,
          RpType: this.Products[i].ProcessStage,
          RpRequirement: this.Products[i].RpRequirement ?? '',
          SnType: this.Products[i].SnType ?? 0,
          Loss: this.Products[i].Loss ?? 0,
          Status: this.Products[i].Status ?? 0,
          OrderNo: this.Products[i].OrderProductNo,
          WorkDocNo: this.Products[i].WorkDocNo,
          ChildGroupNo: this.Products[i].add ? this.Products[i].Bomno : this.Products[i].ChildGroupNo ? this.Products[i].ChildGroupNo : ''
        }

        ProductModels.push(o)

        console.log('ProductModels', ProductModels)

        // this.ProcessModels[i].Processes.forEach(item => {
        //   let o = {
        //     T: item.T,
        //     ProgrammeId: item.ProgrammeId,
        //     ProcessType: item.ProcessType,
        //     DpId: item.DpId ?? 0,
        //     WorkDocProcessId: item.WorkDocProcessId,
        //     WorkDocId:item.WorkDocId,
        //     ProcessId:item.ProcessId,
        //     ProcessSn:item.ProcessSn,
        //     SnType:item.SnType ?? 0,
        //     ConvertRatio:item.ConvertRatio ?? 1,
        //     MachineId:item.MachineId ?? 0,
        //     Length:item.Length ?? 0,
        //     Width:item.Width ?? 0,
        //     Multiple:	item.Multiple ?? 0,
        //     RatedLoss:item.RatedLoss ?? 0,
        //     LossRate:	item.LossRate ?? 0,
        //     PlanIn:	item.PlanIn ?? 0,
        //     PlanOut:	item.PlanOut ?? 0,
        //     PlanOutUnit:item.PlanOutUnit ?? "",
        //     Requirement:item.Requirement ?? "",
        //     Status:item.Status ?? 0,
        //   }
        //   ProcessModels.push(o)
        // })

        // console.log('ProcessModels', ProcessModels)

        this.DetailModels[i]?.DetailModels.forEach(item => {
          let o = {
            T: item.T,
            WorkDocMaterialId: item.WorkDocMaterialId,
            WorkDocId: this.Products[i].WorkDocId,
            ProductId: item.ProductId,
            ColorId: item.ColorId,
            Ration: item.Ration,
            RationUnit: item.RationUnit,
            Quantity: item.qua,
            Remarks: item.Remarks,
            QuantityUnit: item.PdUnitId,
            PropertyId: item.PropertyId ?? 0,
            Rate: item.Rate,
            Loss: item.Loss,
            ChildTeProductId: item.ChildTeProductId ?? 0
          }
          MaterialModels.push(o)
        })
        console.log('MaterialModels', MaterialModels)

        let {
          WorkDocId,
          WorkDocNo = '',
          SchedulingType = 0,
          DpId = 0,
          MaintenanceId = 0,
          ProductionType,
          ProductionDpId = 0,
          DocDate,
          EndTime,
          Remark = '',
          StockQuantity,
          ExistQuantity,
          qua,
          StartTime,
          PickingWarehouseId = PickingWarehouseId ?? 0
        } = this.Products[i]
        if (DpId == null) {
          DpId = 0
        }
        if (MaintenanceId == null) {
          MaintenanceId = 0
        }
        let { start } = this.cycleChange('今天')
        if (StartTime) {
          start = StartTime
        }
        SchedulingType = SchedulingType ?? 0
        DpId = DpId ?? 0
        MaintenanceId = MaintenanceId ?? 0
        ProductionDpId = ProductionDpId ?? 0
        let Quantity = qua - StockQuantity > 0 ? qua - StockQuantity : qua

        let data = {
          Stage: 1,
          WorkDocType: 0,
          ProductType: 0,
          StartTime: start,
          WorkDocId,
          WorkDocNo,
          EndTime,
          SchedulingType,
          DpId,
          MaintenanceId,
          ProductionType,
          ProductionDpId,
          DocDate,
          Remark,
          Quantity,
          PickingWarehouseId: PickingWarehouseId ?? 0
        }

        ProductModels = this.filterData(ProductModels)
        ProcessModels = this.filterData(ProcessModels)
        // MaterialModels = MaterialModels.concat(this.deleteDetailModels)
        MaterialModels = this.filterData(MaterialModels)

        let o1 = {
          ProductModels,
          MaterialModels,
          ...data
        }

        arr.push(o1)
      }

      // 需要删除的
      length = this.deleteProducts.length
      for (let i = 0; i < length; ++i) {
        let ProductModels = []
        let ProcessModels = []
        let MaterialModels = []

        // 对默认值进行设置
        let o = {
          T: this.deleteProducts[i].T,
          WorkDocProductId: this.deleteProducts[i].WorkDocProductId,
          WorkDocId: this.deleteProducts[i].WorkDocId,
          ProductId: this.deleteProducts[i].ProductId,
          PdUnitId: this.deleteProducts[i].PdUnitId,
          ProgrammeId: this.deleteProducts[i].ProgrammeId ?? 0,
          ColorId: this.deleteProducts[i].ColorId,
          PropertyId: this.deleteProducts[i].PropertyId,
          Quantity: this.deleteProducts[i].qua,
          TeProductId: this.deleteProducts[i].TeProductId ?? 0,
          StockQuantity: this.deleteProducts[i].StockQuantity,
          ExistQuantity: this.deleteProducts[i].ExistQuantity,
          SourceDtsId: 0,
          RpType: this.deleteProducts[i].ProcessStage,
          RpRequirement: this.deleteProducts[i].RpRequirement ?? '',
          SnType: this.deleteProducts[i].SnType ?? 0,
          Loss: this.deleteProducts[i].Loss ?? 0,
          Status: this.deleteProducts[i].Status ?? 0,
          OrderNo: this.deleteProducts[i].OrderProductNo,
          WorkDocNo: this.deleteProducts[i].WorkDocNo,
          ChildGroupNo: this.Products[i]?.add ? this.Products[i]?.Bomno : ''
        }

        ProductModels.push(o)

        console.log('ProductModels', ProductModels)

        // this.deleteProcessModels[i]?.Processes.forEach(item => {
        //   let o = {
        //     T: item.T,
        //     ProgrammeId: item.ProgrammeId,
        //     ProcessType: item.ProcessType,
        //     DpId: item.DpId ?? 0,
        //     WorkDocProcessId: item.WorkDocProcessId ?? 0,
        //     WorkDocId:item.WorkDocId ?? 0,
        //     ProcessId:item.ProcessId,
        //     ProcessSn:item.ProcessSn,
        //     SnType:item.SnType ?? 0,
        //     ConvertRatio:item.ConvertRatio ?? 1,
        //     MachineId:item.MachineId ?? 0,
        //     Length:item.Length ?? 0,
        //     Width:item.Width ?? 0,
        //     Multiple:	item.Multiple ?? 0,
        //     RatedLoss:item.RatedLoss ?? 0,
        //     LossRate:	item.LossRate ?? 0,
        //     PlanIn:	item.PlanIn ?? 0,
        //     PlanOut:	item.PlanOut ?? 0,
        //     PlanOutUnit:item.PlanOutUnit ?? "",
        //     Requirement:item.Requirement ?? "",
        //     Status:item.Status ?? 0,
        //   }
        //   ProcessModels.push(o)
        // })

        // console.log('ProcessModels', ProcessModels)

        this.deleteDetailModels[i]?.DetailModels.forEach(item => {
          let o = {
            T: item.T,
            WorkDocMaterialId: item.WorkDocMaterialId,
            WorkDocId: this.deleteProducts[i].WorkDocId,
            ProductId: item.ProductId,
            ColorId: item.ColorId,
            Ration: item.Ration,
            RationUnit: item.RationUnit,
            Quantity: item.qua,
            Remarks: item.Remarks,
            QuantityUnit: item.PdUnitId,
            PropertyId: item.PropertyId ?? 0,
            Rate: item.Rate,
            Loss: item.Loss,
            ChildTeProductId: item.ChildTeProductId ?? 0
          }
          MaterialModels.push(o)
        })
        console.log('MaterialModels', MaterialModels)

        let {
          WorkDocId,
          WorkDocNo = '',
          SchedulingType = 0,
          DpId = 0,
          MaintenanceId = 0,
          ProductionType,
          ProductionDpId = 0,
          DocDate,
          EndTime,
          Remark = '',
          qua,
          StockQuantity,
          ExistQuantity,
          StartTime,
          PickingWarehouseId = PickingWarehouseId ?? 0
        } = this.deleteProducts[i]
        if (DpId == null) {
          DpId = 0
        }
        if (MaintenanceId == null) {
          MaintenanceId = 0
        }
        let { start } = this.cycleChange('今天')
        if (StartTime) {
          start = StartTime
        }
        SchedulingType = SchedulingType ?? 0
        DpId = DpId ?? 0
        MaintenanceId = MaintenanceId ?? 0
        ProductionDpId = ProductionDpId ?? 0
        let Quantity = qua - StockQuantity > 0 ? qua - StockQuantity : qua

        let data = {
          Stage: 3,
          WorkDocType: 0,
          ProductType: 0,
          StartTime: start,
          WorkDocId,
          WorkDocNo,
          EndTime,
          SchedulingType,
          DpId,
          MaintenanceId,
          ProductionType,
          ProductionDpId,
          DocDate,
          Remark,
          Quantity,
          PickingWarehouseId: PickingWarehouseId ?? 0
        }

        ProductModels = this.filterData(ProductModels)
        ProcessModels = this.filterData(ProcessModels)
        // let _MaterialModels = this.deleteLineDetailModels.filter((item) => {
        //   return item.pid === this.Products[i].ProductId;
        // });
        // MaterialModels = MaterialModels.concat(_MaterialModels);
        MaterialModels = this.filterData(MaterialModels)

        let o1 = {
          ProductModels,
          MaterialModels,
          ...data
        }

        arr.push(o1)
      }

      return arr
      // let arr = [];
      // let length =  this.Products.length;

      // for(let i = 0; i < length; ++i){
      //   let ProductModels = [];
      //   let ProcessModels = [];
      //   let MaterialModels = [];
      //   let o1 = {
      //     T: this.Products[i].T,
      //     WorkDocProductId: this.Products[i].WorkDocProductId || 0,
      //     WorkDocId: this.Products[i].WorkDocId,
      //     PdUnitId: this.Products[i].PdUnitId,
      //     ProductId: this.Products[i].ProductId	,
      //     TebomId: this.Products[i].TebomId,
      //     TespecialBomId: this.Products[i].TespecialBomId,
      //     ProgrammeId: this.Products[i].ProgrammeId,
      //     ColorId: this.DetailModels[i].ColorId,
      //     PropertyId: this.DetailModels[i].Property,
      //     RpColorId: this.Products[i].ColorId,
      //     RpPropertyId: this.Products[i].Property,
      //     Quantity: this.Products[i].qua,
      //     StockQuantity: this.Products[i].StockQuantity || 0,
      //     SourceDtsId: 0,
      //     RpType: this.Products[i].ProcessStage,
      //     RpRequirement: "",
      //     SnType: 0,
      //     Loss: 0,
      //     Status: 0,
      //     OrderNo: this.Products[i].OrderProductNo,
      //     WorkDocNo: this.Products[i].WorkDocNo || "",
      //   };

      //   let {
      //     WorkDocId, WorkDocNo = "", SchedulingType = 0,DpId = 0,MaintenanceId = 0,ProductionType,ProductionDpId = 0,DocDate,EndTime,Remark = ""} = this.Products[i];
      //   if(DpId == null){
      //     DpId = 0
      //   }
      //   if(MaintenanceId == null){
      //     MaintenanceId = 0
      //   }
      //   SchedulingType = SchedulingType ?? 0;
      //   DpId = DpId ?? 0;
      //   MaintenanceId = MaintenanceId ?? 0;
      //   ProductionDpId = ProductionDpId ?? 0;
      //   let {start} = this.cycleChange('今天')
      //   let data = {
      //     Stage: 1,
      //     WorkDocType: 0,
      //     ProductType: 0,
      //     StartTime: start,
      //     WorkDocId, WorkDocNo,
      //     EndTime,
      //     SchedulingType,DpId,MaintenanceId,ProductionType,ProductionDpId,DocDate,Remark
      //   }
      //   ProductModels.push(o1)
      //   console.log('data==========', data)
      //   ProductModels = this.filterData(ProductModels)

      //   let obj = {
      //     ProductModels,
      //     ProcessModels: [],
      //     MaterialModels: [],
      //     ...data
      //   }

      //   arr.push(obj)
      // }

      // // 删除
      // let deleteProductsLength =  this.deleteProducts.length;

      // for(let i = 0; i < deleteProductsLength; ++i){
      //   let ProductModels = [];
      //   let ProcessModels = [];
      //   let MaterialModels = [];
      //   let o1 = {
      //     T: this.deleteProducts[i].T,
      //     WorkDocProductId: this.deleteProducts[i].WorkDocProductId || 0,
      //     WorkDocId: this.deleteProducts[i].WorkDocId,
      //     PdUnitId: this.deleteProducts[i].PdUnitId,
      //     ProductId: this.deleteProducts[i].ProductId	,
      //     TebomId: this.deleteProducts[i].TebomId,
      //     TespecialBomId: this.deleteProducts[i].TespecialBomId,
      //     ProgrammeId: this.deleteProducts[i].ProgrammeId,
      //     ColorId: this.deleteDetailModels[i].ColorId,
      //     PropertyId: this.deleteDetailModels[i].Property,
      //     RpColorId: this.deleteProducts[i].ColorId,
      //     RpPropertyId: this.deleteProducts[i].Property,
      //     Quantity: this.deleteProducts[i].qua,
      //     StockQuantity: this.deleteProducts[i].StockQuantity || 0,
      //     SourceDtsId: 0,
      //     RpType: this.deleteProducts[i].ProcessStage,
      //     RpRequirement: "",
      //     SnType: 0,
      //     Loss: 0,
      //     Status: 0,
      //     OrderNo: this.deleteProducts[i].OrderProductNo,
      //     WorkDocNo: this.deleteProducts[i].WorkDocNo || "",
      //   };

      //   let {WorkDocId, WorkDocNo = "", SchedulingType,DpId,MaintenanceId,ProductionType,ProductionDpId,DocDate,EndTime,Remark = ""} = this.deleteProducts[i];
      //   if(DpId == null){
      //     DpId = 0
      //   }
      //   if(MaintenanceId == null){
      //     MaintenanceId = 0
      //   }
      //   SchedulingType = SchedulingType ?? 0;
      //   DpId = DpId ?? 0;
      //   MaintenanceId = MaintenanceId ?? 0;
      //   ProductionDpId = ProductionDpId ?? 0;
      //   let {start} = this.cycleChange('今天')
      //   let data = {
      //     Stage: 1,
      //     WorkDocType: 0,
      //     ProductType: 0,
      //     StartTime: start,
      //     WorkDocId, WorkDocNo,
      //     EndTime,
      //     SchedulingType,DpId,MaintenanceId,ProductionType,ProductionDpId,DocDate,Remark
      //   }
      //   ProductModels.push(o1)

      //   ProductModels = this.filterData(ProductModels)

      //   let obj = {
      //     ProductModels,
      //     ProcessModels: [],
      //     MaterialModels: [],
      //     ...data
      //   }

      //   arr.push(obj)
      // }

      // return arr;
    },
    setDetailModels(data) {
      data = JSON.parse(JSON.stringify(data))

      let ids = this.Products.map(item => {
        return item.ProductId
      })

      let DetailModelsProductId = this.DetailModels.map(item => {
        return item.ProductId
      })

      let _DetailModels = []

      this.deleteProducts = []
      this.deleteProcessModels = []
      this.deleteDetailModels = []

      // 先删除
      data.forEach((item, i) => {
        if (item.delete) {
          let pname = item.Pname
          let productId = item.ProductId

          let DetailModelsIndex = this.DetailModels.findIndex(item => {
            return productId === item.ProductId
          })

          let index = data.findIndex(item => {
            return pname === item.Pname
          })

          data.splice(index, 1)

          let ProductsIndex = this.Products.findIndex(item => {
            return productId === item.ProductId
          })

          if (item.T === 2) {
            this.Products[ProductsIndex].T = 2
            this.DetailModels[DetailModelsIndex].T = 2
            this.deleteProducts.push(this.Products[ProductsIndex])
            this.deleteDetailModels.push(this.DetailModels[DetailModelsIndex])
          }

          this.DetailModels.splice(DetailModelsIndex, 1)
          this.Products.splice(ProductsIndex, 1)

          ids = this.Products.map(item => {
            return item.ProductId
          })

          DetailModelsProductId = this.DetailModels.map(item => {
            return item.ProductId
          })
        }
      })

      // 过滤出非添加的数据
      let newData = data.filter(item => {
        return item.add == null
      })

      // 匹配存在的数据
      newData.forEach((item, i) => {
        item.OrderProductNo = this.OrderProductNo

        let index = ids.indexOf(item.lastProductId)

        if (index !== -1) {
          this.$set(item, 'TebomId', this.Products[index].TebomId)
          this.$set(item, 'TespecialBomId', this.Products[index].TespecialBomId)
          this.$set(item, 'ProgrammeId', this.Products[index].ProgrammeId)
          this.$set(item, 'ProgrammeId', this.Products[index].ProgrammeId)

          let tType = item.T == null ? this.Products[index].T : item.T
          this.$set(item, 'T', tType)
          this.$set(item, 'WorkDocId', this.Products[index].WorkDocId)
          this.$set(item, 'WorkDocProductId', this.Products[index].WorkDocProductId)
          this.$set(item, 'WorkDocNo', this.Products[index].WorkDocNo)
          this.$set(item, 'StockQuantity', this.Products[index].StockQuantity)
          this.$set(item, 'ExistQuantity', this.Products[index].ExistQuantity)
          this.$set(item, 'SchedulingType', this.Products[index].SchedulingType)
          this.$set(item, 'DpId', this.Products[index].DpId)
          this.$set(item, 'MaintenanceId', this.Products[index].MaintenanceId)
          this.$set(item, 'ProductionType', this.Products[index].ProductionType)
          this.$set(item, 'ProductionDpId', this.Products[index].ProductionDpId)
          this.$set(item, 'DocDate', this.Products[index].DocDate)
          this.$set(item, 'EndTime', this.Products[index].EndTime)
          this.$set(item, 'Remark', this.Products[index].Remark)

          let DetailModelsNamIndex = DetailModelsProductId.indexOf(item.ProductId)

          if (DetailModelsNamIndex !== -1) {
            let o = {
              ...this.DetailModels[DetailModelsNamIndex]
            }

            _DetailModels.push(o)
          } else {
            let lastProductIdIndex = DetailModelsProductId.indexOf(item.lastProductId)

            let _data = this.DetailModels[lastProductIdIndex]

            _data.Pname = item.Pname
            _data.Pno = item.Pno
            _data.ProductSpec = item.ProductSpec
            _data.ProcessStage = item.ProcessStage
            _data.ProduceTypeName = item.ProduceTypeName
            _data.ProductId = item.ProductId
            _data.Colors = item.Colors
            _data.PdUnitName = item.PdUnitName
            _data.PdUnitId = item.PdUnitId
            _data.UseProcess = item.UseProcess
            _data.UseColor = item.UseColor
            _data.ColorId = 0
            _data.Property = 0

            _data.Mould = item.Mould
            _data.MouldId = item.MouldId
            _data.MouldName = item.MouldName

            _DetailModels.push(_data)
          }
        } else {
          // this.DetailModels[i].Pname = item.Pname;
          // this.DetailModels[i].Pno = item.Pno;
          // this.DetailModels[i].DetailModels = []
        }
      })

      let addData = data.filter(item => {
        return item.add
      })

      addData.forEach((item, i) => {
        if (item.add) {
          this.$set(item, 'T', 0)
          this.$set(item, 'WorkDocId', 0)
          this.$set(item, 'WorkDocProductId', 0)
          this.$set(item, 'WorkDocNo', '')
          this.$set(item, 'StockQuantity', 0)
          this.$set(item, 'ExistQuantity', 0)
          this.$set(item, 'SchedulingType', null)
          this.$set(item, 'DpId', null)
          this.$set(item, 'MaintenanceId', null)
          this.$set(item, 'ProductionType', item.ProductNature)
          this.$set(item, 'ProductionDpId', item.DefaultSupplier)
          this.$set(item, 'DocDate', this.$commonJs.getToday())
          this.$set(item, 'EndTime', '')
          this.$set(item, 'Remark', '')

          this.$set(item, 'TeProductDetailId', 0)
          this.$set(item, 'TebomId', 0)
          this.$set(item, 'TespecialBomId', 0)
          this.$set(item, 'ProgrammeId', 0)

          let obj = Object.create(this.DetailModels[0])
          console.log('====obj====', obj)

          obj.Pname = item.Pname
          obj.Pno = item.Pno
          obj.ProductSpec = item.ProductSpec
          obj.ProcessStage = item.ProcessStage
          obj.ProduceTypeName = item.ProduceTypeName
          obj.ProductId = item.ProductId
          obj.Colors = item.Colors
          obj.PdUnitName = item.PdUnitName
          obj.PdUnitId = item.PdUnitId
          obj.UseProcess = item.UseProcess
          obj.UseColor = item.UseColor

          obj.Mould = item.Mould
          obj.MouldId = item.MouldId
          obj.MouldName = item.MouldName

          _DetailModels.push(obj)

          item.OrderProductNo = this.OrderProductNo
        }
      })

      newData.push(...addData)

      this.Products = newData
      this.Products.forEach((item, i) => {
        let qua = item.qua
        console.log(`_DetailModels[${i}]`, _DetailModels[i])
        if (_DetailModels[i].qua) {
          _DetailModels[i].qua = qua / _DetailModels[i].rateQua
        }
      })

      this.DetailModels = _DetailModels
    },
    /** 批量操作 */
    handleSelectionChange(val) {
      this.selList = val
    },
    /** 批量-单据日期 */
    onDocDate() {
      this.Products = this.Products.map(obj1 => {
        let duplicateObj = this.selList.find(obj2 => obj2.MakeEmpId === obj1.MakeEmpId && obj2.MouldId === obj1.MouldId)
        if (duplicateObj) {
          obj1.DocDate = this.batchDocDate
        }
        return obj1
      })
      this.batchDocDate = ''
    },
    /** 批量-单据日期 */
    onDocEndTime() {
      this.Products = this.Products.map(obj1 => {
        let duplicateObj = this.selList.find(obj2 => obj2.MakeEmpId === obj1.MakeEmpId && obj2.MouldId === obj1.MouldId)
        if (duplicateObj) {
          obj1.EndTime = this.batchEndTime
        }
        return obj1
      })
      this.batchEndTime = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: flex-end;
  margin: 6px 0;
}
.flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}
</style>
